import { Container, Row, Col, Card } from "react-bootstrap"
import MainLayout from "../../../layouts/MainLayout"
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer/dist/cjs/main";
import { useRef } from "react";
import { connect } from 'react-redux';
import './KendoReport.scss';

const API_SERVER = process.env.REACT_APP_PORTAL_API;
// const API_SERVER = 'https://mportal-400.fiducial.com';
// const API_SERVER = 'https://reporting-200.ffda.com/Proxy';

export const SalesReport = ({
    userSession,
    currentVirtualAccount
}) => {
    const reportRef = useRef(null);
    const userSessionToken = userSession.access_token;
    // const jwt_token = 'eyJhbGciOiJFUzI1NiIsInR5cCI6ImF0K2p3dCIsImtpZCI6IlFvbnlFbUJGaHVUaEhIN1FwM05kZ3g0Y1cxTXJGWjJ4UkxpYzVra1k1c3ciLCJwcm92aWRlciI6IkFNQzo6ZmlkdWNpYWwtY29ubmVjdCJ9.eyJzdWIiOiI1OTY4YmEwZDY2NzlmMTZhN2JkNzk2YWYiLCJlbWFpbCI6ImplYW4ucXVldmFsQGZpZHVjaWFsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJmYW1pbHlfbmFtZSI6IlFVRVZBTC1CT1VSR0VPSVMiLCJnaXZlbl9uYW1lIjoiSmVhbi1DaHJpc3RvcGhlIiwibWlkZGxlX25hbWUiOiIiLCJsb2NhbGUiOiJlbi1VUyIsIm5hbWUiOiJKZWFuLUNocmlzdG9waGUgUVVFVkFMLUJPVVJHRU9JUyIsInVwZGF0ZWRfYXQiOjE2NjI5MzgxMTUsImZpZHVjaWFsX3JvbGVzIjpbIkFjY291bnRhbnQiLCJEYXRhRW50cnkiLCJEaXZpc2lvblJ1bGVzQWRtaW4iLCJhZG1pbiIsImxvZ2luIl0sInJvbGVzIjpbIkFjY291bnRhbnQiLCJEYXRhRW50cnkiLCJEaXZpc2lvblJ1bGVzQWRtaW4iLCJhZG1pbiIsImxvZ2luIl0sImZpZHVjaWFsX2FwaV90b2tlbiI6ImZlZWJiZjZkNDRjYTdhOGY1YmZjZWIyMmI0MDJiZGZhZWNkMjdkNWFhODYxNzU5MmM4NTBkNWVjMjQ5YTg2ZTEiLCJmaWR1Y2lhbF9hczQwMF91c2VybmFtZSI6bnVsbCwianRpIjoiVDFLUm1BYy1obDFzNEJFR3JfOVVhIiwiaWF0IjoxNjYzMTUwMTU4LCJleHAiOjE2NjMxNTczNTgsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZmlkdWNpYWwgZmlkdWNpYWxfYXBpIiwiY2xpZW50X2lkIjoiNTY2NzI4NThlOWZiMTVlOTRiMWY3MWUwIiwiaXNzIjoiaHR0cHM6Ly91YXRhbWMuZmlkdWNpYWwuY29tOjM0NDMiLCJhdWQiOiJodHRwOi8vY29ubmVjdC5maWR1Y2lhbC5jb20iLCJzaWQiOiI1OTY4YmEwZDY2NzlmMTZhN2JkNzk2YWYiLCJzZXNzaW9uVWlkIjoiLWcxdTdGWUV3cUVDVElLOEhhb1hWIiwiY2xpZW50SWQiOiI1NjY3Mjg1OGU5ZmIxNWU5NGIxZjcxZTAiLCJhY2NvdW50SWQiOiI1OTY4YmEwZDY2NzlmMTZhN2JkNzk2YWYiLCJncmFudElkIjoib1RxSE1nZFI1NFhtNWtRWHcyVlZhLVJfYURDMW9RMWlBMnJJNzc3b2dlcyJ9.HxiDbaOw19JI5volFDTJfECw0uIWAke0fQUP9qWox0g8i4ps47TdbmZYgpWBi3VWm4HLCza-hd4aCwJ5oq3p-Q';
    return (
        <MainLayout pageTitle="Sales Activity">
            <Container fluid>
                {/* <Row>
                    <Col>
                        <div className="h4">Sales Activity</div>
                    </Col>
                </Row> */}
                <Row className="mt-4">
                    <Col>
                        <Card
                            className="p-0 overflow-hidden card-rep-radius-top shadow">
                            <div style={{
                                position: 'relative',
                                display: 'block',
                                height: 'calc(100vh - 146px)',
                                width: '100%',
                            }}>
                                <TelerikReportViewer
                                    id="SalesActivity"
                                    ref={reportRef}
                                    authenticationToken={`${userSessionToken} ${currentVirtualAccount ? currentVirtualAccount : ''}`}
                                    serviceUrl={API_SERVER + '/api/v1/telerik/proxy/api/reports/'}
                                    reportSource={{
                                        report: 'SalesPortal/SaleSummaryClient.trdp',
                                        report: 'SalesPortal/SalesActivityBook.trdp',
                                        report: 'SalesPortal-Working/SalesActivityBook.trdp',
                                        parameters: {
                                            Cycle: 'LATEST',
                                        }
                                    }}
                                    viewerContainerStyle = {{
                                        position: 'absolute',
                                        left: '0px',
                                        right: '0px',
                                        top: '0px',
                                        bottom: '0px',
                                        overflow: 'hidden',
                                        clear: 'both',
                                        fontFamily: 'Helvetica'
                                    }}
                                    viewMode="INTERACTIVE"
                                    scaleMode="SPECIFIC"
                                    scale={1.0}
                                    enableAccessibility={false}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </MainLayout>
    )
};

const mapStateToProps = (appState) => ({
    userSession: appState.session,
    currentVirtualAccount: appState.currentVirtualAccount,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SalesReport);
